import {Trans} from 'gatsby-plugin-react-i18next';

const HelloBarEs = ({ scroll1 }) => (
    <div
        className="hellobar hellobarSpace barslideDown"
        id="helloBar"
    >
        {/* <button type="button" className="close" onClick={() => closeHelloBar()}>
            <span>
                <svg
                    className="crossico"
                    width="30"
                    height="30"
                    viewBox="0 0 17 17"
                >
                    <path
                        className="fill_path"
                        fillRule="evenodd"
                        d="M16.293 1.592l-1.3-1.3-6.7 6.701-6.7-6.7-1.3 1.299 6.7 6.7-6.7 6.701 1.3 1.3 6.7-6.7 6.7 6.7 1.3-1.3-6.7-6.7z"
                    ></path>
                </svg>
            </span>
        </button> */}
        <div className="helloDiv text-center">
            <div className="hellobarContent">
                {/* The Global Corporate Walkathon is back with season ✌️
                <b> Register for the event NOW!</b> */}
                Una Guía Completa Del Programa De Bienestar Corporativo
            </div>
            <div className="hellobar-cta">
                <a
                    id="hellobarbtn"
                    href="https://www.vantagefit.io/es/resources/guia-programas-de-bienestar-corporativo/"
                >
                    <Trans>Download Now</Trans>
                </a>
            </div>
        </div>
    </div>
)
function closeHelloBar() {
    sessionStorage.setItem(`helloBar`, false)
    document.getElementsByClassName(`header_area`)[0].classList.remove(`mainpid`)
    // toggleHellobar()
    console.log('working')
}
export default HelloBarEs
